export default __webpack_public_path__ + "static/media/vuesax-linear-stickynote.28b4e283.svg";